import { defineComponent, computed, createBlock, openBlock, unref, withCtx, renderSlot } from "vue";
import { useFormField } from "./useFormField.js";
import { S as Slot } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/Primitive/Slot.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FormControl",
  setup(__props) {
    const formField = useFormField(), describedbyRef = computed(() => {
      let describedbyText = formField.formDescriptionId;
      return formField.error.value && (describedbyText += ` ${formField.formMessageId}`), describedbyText;
    });
    return (_ctx, _cache) => (openBlock(), createBlock(unref(Slot), {
      id: unref(formField).formItemId,
      "data-slot": "form-control",
      "aria-describedby": describedbyRef.value,
      "aria-invalid": !!unref(formField).error.value
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "aria-describedby", "aria-invalid"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FormControl.js.map
